import React from 'react';

export const NewLogisticOperator = React.lazy(
  () => import('./NewLogisticOperator')
);
export const EditLogisticOperator = React.lazy(
  () => import('./EditLogisticOperator')
);

export const TimeSlots = React.lazy(() => import('./TimeSlots'));
export const NewTimeSlot = React.lazy(() => import('./NewTimeSlot'));
export const EditTimeSlot = React.lazy(() => import('./EditTimeSlot'));
export const NewAssignment = React.lazy(() => import('./CreateAssignment'));
export const EditServiceWithOperator = React.lazy(
  () => import('./EditServiceWithOperator')
);
export const ZonesList = React.lazy(() => import('./ZonesList'));
export const EditZone = React.lazy(() => import('./EditZone'));
export const ViewZone = React.lazy(() => import('./ViewZone'));
export const LogisticOperatorCommerces = React.lazy(
  () => import('./LogisticOperatorCommerces')
);
export const NewLogisticOperatorCommerce = React.lazy(
  () => import('./NewLogisticOperatorCommerce')
);
export const ServiceRulesConfig = React.lazy(
  () => import('./ServiceRulesConfig')
);
export const EditServiceRulesConfig = React.lazy(
  () => import('./EditServiceRulesConfig')
);
export const Transitions = React.lazy(() => import('./Transitions'));
export const NewTransition = React.lazy(() => import('./NewTransition'));
export const EditTransition = React.lazy(() => import('./EditTransition'));
